import React, { useContext, useEffect } from 'react';
import {LocaleContext} from '../LocaleContextProvider';
import {ConfigContext} from '../ConfigContextProvider';
import { FormattedMessage , injectIntl} from 'react-intl';

import {
  NavLink} from "react-router-dom";

const HomePage = (props) => {
const {ASSETS_URL} = useContext(ConfigContext);


useEffect(() => {

  }, []);

  return (
    <div className="HomePage">
        <div className="HomePage__background" style={{backgroundImage: `url("${ASSETS_URL}/home.jpg") ` }}/>
        <div className="HomePage__textContent">
          <h2 className="HomePage__title"><FormattedMessage id={"homepage.title"} /></h2>
          <h3 className="HomePage__subtitle" dangerouslySetInnerHTML={  {__html: props.intl.formatMessage({id: "homepage.subtitle"})}  } ></h3>
          <p className="HomePage__description" dangerouslySetInnerHTML={  {__html: props.intl.formatMessage({id: "homepage.description"})}  } />
          
          <div className="HomePage__steps">
            <div className="HomePage__stepItem">

              <div className="HomePage__stepItemImage">
                <img src={`${ASSETS_URL}/steps/step1.svg`} />
              </div>
              <h3 className="HomePage__stepItemTitle"><FormattedMessage id={"homepage.step1.title"} /></h3>
              <p className="HomePage__stepItemDescription"><FormattedMessage id={"homepage.step1.description"} /></p>
            </div>

            <div className="HomePage__stepItem">
              <div className="HomePage__stepItemImage">
                <img src={`${ASSETS_URL}/steps/step2.svg`} />
              </div>

              <h3 className="HomePage__stepItemTitle"><FormattedMessage id={"homepage.step2.title"} /></h3>
              <p className="HomePage__stepItemDescription"><FormattedMessage id={"homepage.step2.description"} /></p>

            </div>

            <div className="HomePage__stepItem">

              <div className="HomePage__stepItemImage">
                <img src={`${ASSETS_URL}/steps/step3.svg`} />
              </div>

              <h3 className="HomePage__stepItemTitle"><FormattedMessage id={"homepage.step3.title"} /></h3>
              <p className="HomePage__stepItemDescription"><FormattedMessage id={"homepage.step3.description"} /></p>

            </div>


          </div>
          
          
          <NavLink to={props.to} className="HomePage__btn"><FormattedMessage id={"homepage.cta"} /></NavLink>
          <p className="HomePage__terms" dangerouslySetInnerHTML={  {__html: props.intl.formatMessage({id: "terms.description"})}  } />
        </div>
    </div>
  );

}

export default injectIntl(HomePage);